import { useQueryClient } from '@tanstack/react-query';
import { B2BAuthContext } from '../../Context/AuthContex/B2BAuthContext';
import { useExhibitorAuthContext } from '../../Context/AuthContex/ExhibitorAuthContext';
import { VisitorAuthContext } from '../../Context/AuthContex/VisitorAuthContext';
import {
  AUTH_VISITOR_USER_FAILED,
  B2B_USER_FAILED,
  EXHIBITOR_USER_FAILED,
} from '../../Helpers/Constant';
import CustomHeader from './CustomHeader';
const Header = () => {
  const queryClient = useQueryClient();
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();

  const { visitorUser, dispatch: VisitorAuthDispatch } = VisitorAuthContext();
  const {
    state: { b2bUser },
    dispatch: B2BAuthDispatch,
  } = B2BAuthContext();

  const handleLogoutExhibitor = () => {
    authDispatch?.({
      type: EXHIBITOR_USER_FAILED,
    });
    queryClient.clear();
  };
  const handleLogout = () => {
    VisitorAuthDispatch?.({
      type: AUTH_VISITOR_USER_FAILED,
    });
    queryClient.clear();
  };

  const handleLogoutB2B = () => {
    B2BAuthDispatch?.({
      type: B2B_USER_FAILED,
    });

    queryClient.clear();
  };

  return (
    <>
      <CustomHeader />
    </>
  );
};

export default Header;
